import {userService} from '../../_services'

export default {
  state: {
    user: JSON.parse(localStorage.getItem('user')),
    maxUsers: 10,
    myCustomers: [],
    allUsers: [],
    roles: [],
    loginFailed: false
  },
  mutations: {
    setUser (state, payload) {
      state.user = payload
    },
    setRoles (state, payload) {
      state.roles = payload
    },
    setEditedUser (state, payload) {
      var foundIndex = state.allUsers.findIndex(user => user.id === payload.id)
      if (foundIndex > -1) state.allUsers.splice(foundIndex, 1, payload)
    },
    setUsers (state, payload) {
      state.allUsers = payload
    },
    addUser (state, payload) {
      if (state.allUsers.length === state.maxUsers) {
        state.allUsers.push(payload)
        state.maxUsers += 1
      }
    },
    addUsers (state, payload) {
      if (state.allUsers.length <= (state.maxUsers - payload.length)) {
        state.allUsers = state.allUsers.concat(payload)
      }
    },
    removeUser (state, payload) {
      var foundIndex = state.allUsers.findIndex(user => user.id === payload)
      if (foundIndex > -1) {
        state.allUsers.splice(foundIndex, 1)
        state.maxUsers -= 1
      }
    },
    setMaxUsers (state, payload) {
      state.maxUsers = payload
    },
    setLoginFailed (state, payload) {
      state.loginFailed = payload
    }
  },
  actions: {
    signUserIn ({dispatch, commit, state}, payload) {
      commit('setLoginFailed', false)
      dispatch('startLoading', true)
      userService.login(payload.email, payload.password)
        .then(() => commit('setLoginFailed', false))
        .catch(error => {
          commit('setLoginFailed', true)
          dispatch('handleError', error)
        })
        .finally(() => dispatch('stopLoading', false))
    },
    signUserOut () {
      userService.logout()
    },
    loadRoles ({dispatch, commit}) {
      userService.getAllRoles()
        .then(response => {
          commit('setRoles', response.data)
        })
        .catch(error => dispatch('handleError', error))
    },
    loadUserData ({dispatch}, user) {
      userService.fetchUserData(user)
        .catch(error => dispatch('handleError', error))
        .finally(() => dispatch('stopDataLoading'))
    },
    loadUsers ({dispatch, commit}, filter) {
      dispatch('startDataLoading')
      userService.searchUsers(filter.searchTerms, filter.page, filter.size)
        .then(response => {
          commit('setMaxUsers', response.data.totalElements)
          commit('addUsers', response.data.content)
        })
        .catch(error => dispatch('handleError', error))
        .finally(() => dispatch('stopDataLoading'))
    },
    resetUsers ({commit}) {
      commit('setUsers', [])
      commit('setMaxUsers', 10)
    },
    logout ({commit}) {
      userService.logout()
    },
    addUser ({dispatch, commit}, user) {
      dispatch('startLoading')
      userService.createUser(user)
        .then(response => {
          commit('addUser', response.data)
        })
        .then(() => dispatch('showNotification', {
          title: 'Mitarbeiter erfolgreich angelegt.',
          type: 'primary'
        }))
        .catch(error => dispatch('handleError', error))
        .finally(() => dispatch('stopLoading'))
    },
    editUser ({dispatch, commit}, user) {
      dispatch('startLoading')
      userService.updateUser(user)
        .then(response => {
          commit('setEditedUser', response.data)
        })
        .then(() => dispatch('showNotification', {
          title: 'Mitarbeiter erfolgreich geändert.',
          type: 'primary'
        }))
        .catch(error => dispatch('handleError', error))
        .finally(() => dispatch('stopLoading'))
    },
    deleteUser ({dispatch, commit}, userId) {
      dispatch('startLoading')
      userService.deleteUser(userId)
        .then(() => {
          commit('removeUser', userId)
        })
        .then(() => dispatch('showNotification', {
          title: 'Mitarbeiter erfolgreich gelöscht.',
          type: 'primary'
        }))
        .catch(error => dispatch('handleError', error))
        .finally(() => dispatch('stopLoading'))
    }
  },
  getters: {
    user (state) {
      return state.user
    },
    allUsers (state) {
      return state.allUsers
    },
    maxUsers (state) {
      return state.maxUsers
    },
    roles (state) {
      return state.roles
    },
    loginFailed (state) {
      return state.loginFailed
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/user/index.js